<template>
  <div>
    <location-lookup
      v-model="search"
      :lat="lat"
      :lng="lng"
      @located="emitLocated"
    ></location-lookup>
  </div>
</template>
<script>
import LocationLookup from '@/components/Generic/Form/LocationLookup';

export default {
  props: {
    lat: [Number, String],
    lng: [Number, String],
    location: {
      type: String,
      default: null
    }
  },

  components: {
    LocationLookup
  },

  data() {
    return {
      search: null
    };
  },

  methods: {
    emitLocated(map) {
      this.$emit('located', {
        map,
        location: this.search
      });
    }
  },

  watch: {
    location: {
      handler(value) {
        this.search = value;
      },
      immediate: true
    }
  }
};
</script>
